import React, { useEffect, useState } from 'react';
import { WrapperExternal, Dialog } from '@/components/atoms';
import {
  ProductSlider,
  ProductInfo,
  FutureFashion,
} from '@/components/molecules';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { RootState } from '@/store/store';
import { VariantInfo } from '@/types/catalog';
import { IMainProductCmp } from './IMainProductCmp';
import { getProductIdFutureFashion } from '@/lib/api.product';
import { dispatchCustomEvent } from '@/utils/Impressions';
import { isErr } from '@/utils/typings/result';
import { ProductWithVariants, Variant } from '@/lib/models/types/product';
import { ICurrencyInfo } from '@/types/ICurrencyInfo';

interface ISlideCollection {
  src: string;
  width: number;
  height: number;
  title: string;
}

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${props => props.theme.breakpoints.up('tablet')} {
    flex-direction: row;
    gap: 24px;
  }
  ${props => props.theme.breakpoints.up('md')} {
    gap: 32px;
  }
`;

const FlexItemLeft = styled.div`
  width: 100%;
  padding: 0 0;
  ${props => props.theme.breakpoints.up('tablet')} {
    width: 50%;
  }
  /* ${props => props.theme.breakpoints.up('md')} {
    width: 55%;
  } */
  ${props => props.theme.breakpoints.up('lg')} {
    /* width: 65%; */
    width: 53%;
    max-width: 960px;
  }
`;
const FlexItemRight = styled.div`
  width: 100%;
  margin-left: 0;
  padding: 24px 8px;

  ${props => props.theme.breakpoints.up('tablet')} {
    padding: 0;
    /* max-width: 400px; */

    width: 47%;
  }

  /* ${props => props.theme.breakpoints.up('md')} {
    width: 45%;
  } */
  ${props => props.theme.breakpoints.up('laptop')} {
    padding: 0 16px;

    /* max-width: 960px; */
  }
  ${props => props.theme.breakpoints.up('lg')} {
    /* width: 35%; */
    padding: 0;
  }
`;
// const CustomWrapperExternal = styled(WrapperExternal)`
//   //TODO :  this is temporary,  remove it  when rebranding set new max app max width to 1920px
//   max-width: ${props => {
//     return props
//       ? props.template === 'FullWidth'
//         ? '100vw'
//         : '1920px'
//       : '1920px';
//   }};
// `;

const productDetailEvent = (
  product: ProductWithVariants,
  currency: ICurrencyInfo
) =>
  dispatchCustomEvent('productDetails', {
    product,
    currency,
  });

const MainProduct: React.FC<IMainProductCmp> = props => {
  const { productObj, shippingInfo, availabilityInfos, brandSlug } = props;

  const customer = useSelector(
    (state: RootState) => state.userReducer.customer
  );
  const isUsUser: boolean =
    customer && customer?.defaultAddress?.countryCodeV2 === 'US';

  const currency = useSelector(
    (state: RootState) => state.currencyReducer.currency
  );
  const [url, setUrl] = useState('');

  const [variant, setVariant] = useState({
    id: productObj?.variant.id,
    imageSrc: productObj.images[0]?.url,
  });

  const variantAttributes = productObj.productMetafields.variantsAttributes;

  const [open3d, setOpen3d] = useState<boolean>(false);
  const [productId3d, setProductId3d] = useState<string | null>(null);

  const [missingOptions, setMissingOptions] = useState<boolean>(false);
  const [selectedOptions, setSelectedOptions] = useState<{
    [key: string]: string;
  } | null>(null);

  const [slideCollection, setSlideCollection] = useState<{
    items: ISlideCollection[];
  }>({
    items: [],
  });

  const router = useRouter();

  const fetchProductIdFutureFashion = async (handle: string) => {
    const result = await getProductIdFutureFashion(handle);

    if (isErr(result)) {
      // TODO: Error Handling
      setProductId3d(null);
      return;
    }

    const { productByHandle } = result.result;
    if (
      productByHandle &&
      productByHandle.viewer_product_id &&
      productByHandle.viewer_product_id.value &&
      productByHandle.viewer_product_id.value !== ''
    ) {
      setProductId3d(productByHandle.viewer_product_id.value);
    } else {
      setProductId3d(null);
    }
  };
  useEffect(() => {
    if (currency && currency.isoCode !== '') {
      productDetailEvent(productObj, currency);
    }
  }, [productObj, currency]);

  useEffect(() => {
    if (productObj && productObj.handle) {
      fetchProductIdFutureFashion(productObj.handle);
    }

    setVariant({
      id: productObj.variant.id,
      imageSrc: productObj?.images[0]?.url,
    });

    if (missingOptions) {
      setMissingOptions(false);
    }

    setUrl(window.location.href);
    let selOptions = {};

    if (productObj?.options) {
      for (const option of productObj.options) {
        if (option.values && option.values.length === 1) {
          selOptions = {
            ...selOptions,
            [option.name.toLowerCase()]: option.values[0],
          };
        }
      }
    }

    setSelectedOptions(selOptions);
  }, [router]);

  useEffect(() => {
    if (
      selectedOptions &&
      Object.keys(selectedOptions).length === optionsNumber
    ) {
      let foundMatches = 0;
      if (productObj && productObj.options) {
        productObj?.options.forEach(option => {
          let lowerOptionName = option.name.toLowerCase();
          option.values.forEach(opt => {
            if (selectedOptions[lowerOptionName]) {
              if (
                selectedOptions[lowerOptionName].toLowerCase() ===
                opt.toLowerCase()
              ) {
                foundMatches++;
              } else {
                return;
              }
            }
          });
        });
        if (foundMatches === optionsNumber) {
          const multiFilter = (
            arr: Variant[],
            filters: { [key: string]: string }
          ) => {
            const filterKeys = Object.keys(filters);
            return arr.filter(eachObj => {
              const variantOptions = eachObj.options;
              return filterKeys.every((eachKey: string) => {
                const option = variantOptions?.find(
                  option => option.name.toLowerCase() === eachKey.toLowerCase()
                );
                return (
                  option?.value.toLowerCase() === filters[eachKey].toLowerCase()
                );
              });
            });
          };

          const res = multiFilter(
            productObj.variants,
            selectedOptions
          ) as VariantInfo[];

          if (res && res.length > 0) {
            setVariant({
              id: res[0].variant_id || '',
              imageSrc: res[0].image_object?.url || '',
            });
          } else {
            //alert('not found');
          }
          return;
        }
      }
    }
  }, [selectedOptions]);

  useEffect(() => {
    let slideCollection: {
      items: ISlideCollection[];
    } = {
      items: [],
    };

    if (productObj && productObj.images) {
      productObj.images.forEach(image => {
        let w = image.width;
        let h = image.height;
        if (image.width > 1024) {
          w = 1024;
          h = (image.height * 1024) / image.width;
        }

        if (image.url === variant.imageSrc) {
          slideCollection.items.unshift({
            src: image.url,
            width: w,
            height: h,
            title: productObj.title,
          });
        } else {
          slideCollection.items.push({
            src: image.url,
            width: w,
            height: h,
            title: productObj.title,
          });
        }
      });

      setSlideCollection(slideCollection);
    }
  }, [variant]);

  const openFutureFashion = () => {
    setOpen3d(true);
  };

  const closeFutureFashion = () => {
    setOpen3d(false);
  };

  let optionsNumber = productObj?.options?.length;

  const onChangeHandler = (type: string, value: string) => {
    setSelectedOptions({ ...selectedOptions, [type.toLowerCase()]: value });
  };

  return (
    <>
      <WrapperExternal>
        <FlexContainer>
          <FlexItemLeft>
            <ProductSlider
              slideCollection={slideCollection}
              openFutureFashion={openFutureFashion}
              show3dicon={productId3d}
              url={url}
            />
          </FlexItemLeft>
          <FlexItemRight>
            {currency && (
              <ProductInfo
                isUsUser={isUsUser}
                currency={currency}
                shippingInfo={shippingInfo}
                onChangeHandler={onChangeHandler}
                selectedOptions={selectedOptions}
                variantAttributes={variantAttributes || []}
                availabilityInfos={availabilityInfos}
                show3dicon={productId3d}
                openFutureFashion={openFutureFashion}
                product={productObj}
                brandSlug={brandSlug}
              />
            )}
          </FlexItemRight>
        </FlexContainer>
      </WrapperExternal>
      {open3d && productId3d ? (
        <Dialog open={open3d} onClose={closeFutureFashion}>
          <FutureFashion productId={productId3d} />
        </Dialog>
      ) : null}
    </>
  );
};

export default MainProduct;
